import { CustomRangeSelectionStrategy } from 'src/app/blight-v2/shared/strategies/custom-range-selection.strategy';

import { BlightDayRange, PhytophthoraPressure } from '../../models/models';

export const defaultBlightDayRange: BlightDayRange = {
  daysInPast: 5,
  daysInFuture: 5,
};

export const formatBlightDate = (date: Date) =>
  `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

export const buildBlightRequestedDates = (blightDayRange: BlightDayRange, startDate: Date = new Date()) => {
  const pastDate = new Date(startDate);
  pastDate.setDate(pastDate.getDate() - blightDayRange.daysInPast);
  const futureDate = new Date(startDate);
  futureDate.setDate(futureDate.getDate() + blightDayRange.daysInFuture);

  return [formatBlightDate(pastDate), formatBlightDate(futureDate)];
};

export const dateTimeToStringLocale = (date: Date) => date.toLocaleString('nl-NL', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})
  .replace(/-/g, '/');

export const phytophthoraPressureOptions = [
  PhytophthoraPressure.low,
  PhytophthoraPressure.normal,
  PhytophthoraPressure.high,
];

export const phytophthoraPressureApiMap = {
  [PhytophthoraPressure.low]: -1,
  [PhytophthoraPressure.normal]: 0,
  [PhytophthoraPressure.high]: 1,
};

export const customRangeSelectionStrategyFactory = () =>
  new CustomRangeSelectionStrategy<Date>(11);
